export const START_WHATSAPP_OPTIN = "START_WHATSAPP_OPTIN";
export const ERROR_WHATSAPP_OPTIN = "ERROR_WHATSAPP_OPTIN";
export const SAVE_WHATSAPP_OPTIN = "SAVE_WHATSAPP_OPTIN";